import { render, staticRenderFns } from "./TargetAudience.vue?vue&type=template&id=6ce67709"
import script from "./TargetAudience.vue?vue&type=script&lang=js"
export * from "./TargetAudience.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports